/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  func-names,
  import/no-extraneous-dependencies,
  no-script-url,
  no-sequences,
  no-useless-constructor,
  no-useless-escape,
  one-var,
  prefer-const,
  prefer-rest-params
*/
import React from 'react';

module.exports = class ContactLink extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {

    if (process.env.NODE_ENV === 'test') {
      return;
    }

    /* eslint-disable no-unused-expressions */
    window.zEmbed || (function (e, t) {
      let n,
        o,
        d,
        i,
        s,
        a = [],
        r = document.createElement('iframe');
      window.zEmbed = function () {
        a.push(arguments);
      }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
      try {
        o = s;
      } catch (c) {
        n = document.domain, r.src = 'javascript:var d=document.open();d.domain=\"" + n + "\";void(0);', o = s;
      }
      o.open()._l = function () {
        const o = this.createElement('script');
        n && (this.domain = n), o.id = 'js-iframe-async', o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
      }, o.write('<body onload=\"document._l();\">'), o.close();
    }('https://assets.zendesk.com/embeddable_framework/main.js', 'hellosign.zendesk.com')); /* ]]> */
    zE(() => {
      zE.hide();
    });
  }

  handleClick() {
    zE(() => {
      zE.activate({ hideOnClose: true });
    });
  }

  render() {
    const contactText = this.props.contactText || 'Contact';
    return <a href='javascript:;' onClick={() => this.handleClick()}>{contactText}</a>;
  }
};
